import { alpha } from '@mui/material/styles';

export const MAINTENANCE_PRIORITY_ORDER = { HIGH: 0, MEDIUM: 1, LOW: 2 };

export const MAINTENANCE_PRIORITY_META = {
  HIGH: {
    label: 'High',
    color: '#f44336',
    gradient: 'linear-gradient(135deg, #ef5350 0%, #c62828 100%)',
    glow: 'rgba(244, 67, 54, 0.45)',
  },
  MEDIUM: {
    label: 'Medium',
    color: '#ff9800',
    gradient: 'linear-gradient(135deg, #ffb74d 0%, #f57c00 100%)',
    glow: 'rgba(255, 152, 0, 0.42)',
  },
  LOW: {
    label: 'Low',
    color: '#66bb6a',
    gradient: 'linear-gradient(135deg, #81c784 0%, #43a047 100%)',
    glow: 'rgba(76, 175, 80, 0.38)',
  },
};

export function normalizeMaintenanceRequests(room) {
  if (!room) return [];
  if (Array.isArray(room.maintenance_requests)) return room.maintenance_requests;
  if (Array.isArray(room.maintenanceRequests)) return room.maintenanceRequests;
  return [];
}

export function getHighestMaintenancePriority(requests) {
  const list = Array.isArray(requests) ? requests : [];
  if (!list.length) return null;
  const sorted = [...list].sort(
    (a, b) =>
      (MAINTENANCE_PRIORITY_ORDER[String(a?.priority || '').toUpperCase()] ?? 9)
      - (MAINTENANCE_PRIORITY_ORDER[String(b?.priority || '').toUpperCase()] ?? 9)
  );
  return String(sorted[0]?.priority || '').toUpperCase() || null;
}

export function getMaintenancePriorityMeta(priority) {
  const key = String(priority || '').toUpperCase();
  return MAINTENANCE_PRIORITY_META[key] || {
    label: key || 'Maintenance',
    color: '#78909c',
    gradient: 'linear-gradient(135deg, #90a4ae 0%, #607d8b 100%)',
    glow: 'rgba(120, 144, 156, 0.35)',
  };
}

export function resolveRoomMaintenanceSummary(room) {
  const requests = normalizeMaintenanceRequests(room);
  const priority = getHighestMaintenancePriority(requests)
    || String(room?.maintenance_priority || '').toUpperCase()
    || null;
  return {
    requests,
    count: requests.length,
    hasMaintenance: requests.length > 0 || Boolean(room?.has_maintenance),
    priority,
    meta: priority ? getMaintenancePriorityMeta(priority) : null,
    topIssue: requests[0]?.issue_type || '',
  };
}

export function getMaintenanceCardAccentSx(priority, isDark) {
  const meta = getMaintenancePriorityMeta(priority);
  return {
    borderLeft: `4px solid ${meta.color}`,
    boxShadow: isDark
      ? `0 8px 24px ${alpha(meta.color, 0.28)}, inset 0 1px 0 ${alpha('#fff', 0.05)}`
      : `0 8px 22px ${alpha(meta.color, 0.18)}`,
  };
}

export function getMaintenanceChipSx(priority, isDark, { compact = false } = {}) {
  const meta = getMaintenancePriorityMeta(priority);
  return {
    height: compact ? 20 : 24,
    fontSize: compact ? '0.62rem' : '0.7rem',
    fontWeight: 800,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    color: '#fff',
    background: meta.gradient,
    border: `1px solid ${alpha('#fff', isDark ? 0.28 : 0.45)}`,
    boxShadow: `0 2px 10px ${meta.glow}`,
    '& .MuiChip-icon': {
      color: '#fff !important',
      ml: compact ? 0.35 : 0.5,
    },
    '& .MuiChip-label': {
      px: compact ? 0.75 : 1,
    },
  };
}
